'use client';

import { useEffect, useState, type ReactNode } from 'react';

/** 首次資料淡入時讓骨架同步淡出；回訪的位移動畫由分頁暫存記錄觸發一次。 */
export function MiniAppPageTransition({ ready, firstReveal, animateReturn, skeleton, children }: {
  ready: boolean; firstReveal: boolean; animateReturn: boolean; skeleton: ReactNode; children: ReactNode;
}) {
  const [showSkeleton, setShowSkeleton] = useState(!ready || firstReveal);
  const [startedWithSkeleton] = useState(firstReveal);
  useEffect(() => {
    if (!ready) { setShowSkeleton(true); return; }
    const timer = window.setTimeout(() => setShowSkeleton(false), 180);
    return () => window.clearTimeout(timer);
  }, [ready]);
  return <div className={`miniapp-page-transition${ready ? ' is-ready' : ''}`}>
    {showSkeleton && <div className="miniapp-skeleton-layer" aria-hidden={ready || undefined}>{skeleton}</div>}
    <div hidden={!ready} className={`miniapp-content-layer${animateReturn ? ' is-return' : startedWithSkeleton ? ' is-first' : ''}`}>{children}</div>
  </div>;
}
